import React from "react"
import Layout from "../components/pages/WindscreenClaim/Layout"
import SEO from "../components/seo"
import BaseForm from "../components/pages/WindscreenClaim/BaseForm"
import { createStore } from "redux"
import allReducer from "../Redux/WindscreenClaim/reducers"
import { Provider } from "react-redux"

/** Create redux store */
const store = createStore(
  allReducer
  // ,
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

const Index = () => (
  <Provider store={store}>
    <Layout>
      <SEO title="Windscreen Claim" />
      <BaseForm></BaseForm>
    </Layout>
  </Provider>
)

export default Index
